import { render, staticRenderFns } from "./InvestorForm.vue?vue&type=template&id=baff041c&"
import script from "./InvestorForm.vue?vue&type=script&lang=js&"
export * from "./InvestorForm.vue?vue&type=script&lang=js&"
import style0 from "./InvestorForm.vue?vue&type=style&index=0&id=baff041c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports